/* eslint-disable import/prefer-default-export */
export const rowsPerPage: number = 25;
